import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';


var service_data = require("./nservices.json");

class Collapsible extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            open: false
        }
        this.togglePanel = this.togglePanel.bind(this);
    }

    togglePanel(e){
        this.setState({open: !this.state.open})
    }

    componentDidUpdate(){
        
    }

    render() {
      return (<div>
        <div onClick={(e)=>this.togglePanel(e)} className='header'>
            {this.props.title}</div>
        {this.state.open ? (
            <div className='content'>
                {this.props.children}
            </div>
            ) : null}
      </div>);
    }
  }

class App extends React.Component {
   constructor(props) {
       super(props);
       this.state = {
	   data: service_data,
	   base_uri: "https://www.atlas.cdmx.gob.mx/descargas/bk"
       }
    
   }
    stuff(x, service){
	return(
	    <li>
		<p>{service}/{x}</p>
	    </li>
	);
    }

    render() {
	const data = this.state.data
	const mapper = data.map((x, i) =>{
	    let service = x.service;
	    let type = x.type;
	    let substr = "&s=" + service + "&t=" + type;
	    let u = this.state.base_uri + "?f=shp" + substr;
	    let g = this.state.base_uri + "?f=geojson" + substr;
	    const baselist = x.layers.base.map((a, b)=>{
		let lyr_substr = "&i=" + a.id;
		var url_shp = u + lyr_substr;
		var url_geojson = g + lyr_substr;
		// let geojson_file = a.fname + ".geojson"
		return(
		    <li key={a.id}>
			<p>{a.name}</p>
			<a href={url_shp}>ShapeFile</a>
			<a href={url_geojson}>GeoJSON</a>
		    </li>
		)
	    });
	    const groupList = Object.entries(x.layers.grupos).map((y)=>{
		let grupo = y[0];
		const glist = y[1].map((z) => {
		    let lyr_substr = "&i=" + z.id;
		    if (Object.keys(z).includes('service')){
			let altst = "&s=" + z.service + "&t=" + z.type;
			let altu = this.state.base_uri + "?f=shp" + altst;
			let altg = this.state.base_uri + "?f=geojson" + altst;
			var ushp = altu + lyr_substr;
			var ugeojson = altg + lyr_substr;
			
		    } else {
			var ushp = u + lyr_substr;
			var ugeojson = g + lyr_substr;
		    }
		    return (
			    <li key={z.id}>
			    <p>{z.name}</p>
			    <a href={ushp}>ShapeFile</a>
			    <a href={ugeojson}>GeoJSON</a>
			    </li>
		    );
		});
		return(
			<li>
			<h3>{grupo}</h3>
			<ol>{glist}</ol>
			</li>
		);
	    });
	    return(
		<li key={i}>
		    <Collapsible title={x.title}>
			<div>
		    <ol>{baselist}</ol>
		    <ul>{groupList}</ul>
			</div>
		    </Collapsible>
		</li>
	    );
	});
	return  (
	    <div>
		<h1>Repositorio de descargas</h1>
		<ul>{mapper}</ul>
	    </div>
	);
    };
}

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
